<script>
    import { PowerTable } from "@muonw/powertable";
    import { onMount, tick, onDestroy, createEventDispatcher } from "svelte";
    import * as bootstrap from "bootstrap";
    import tagService from "../service.js";
    import Form from "../_form.svelte";
    import MassiveAddForm from "../_form_massive_add.svelte";
    import { notificate } from "../../../services/notification";
    import powerTableService from "../../../services/powerTable.js";
    import AddAssetsTag from "./add-assets-tag.svelte";
    import AddFindingsTag from "./add-findings-tag.svelte";
    import AddVulnerabilitiesTag from "./add-vulnerabilities-tag.svelte";
    import RemoveTagAssets from "./remove-tag-assets.svelte";
    import RemoveTagFindings from "./remove-tag-findings.svelte";
    import RemoveTagVulnerabilities from "./remove-tag-vulnerabilities.svelte";
    import AnchorRow from "../../../components/powerTable/anchor-row.svelte";
    import DropdownRow from "../../../components/powerTable/dropdown-row.svelte";
    import { assetsLimits, user } from "../../user/user.state.svelte.js";
    import { assets } from "../../asset/assets.state.svelte.js";
    import { findings } from "../../finding/findings.state.svelte.js";
    import { vulnerabilities } from "../../vulnerability/vulnerabilities.state.svelte.js";
    import { fade } from "svelte/transition";
    import { format } from "svelte-i18n";

    const dispatch = createEventDispatcher();
    let {
        data = [],
        getTagsAndAssociations = (x) => x,
        loading = false,
        updateTags = (x) => x,
    } = $props();

    let selected_rows = $state([]);
    let ShowMassiveAdditionForm = false;
    let formAddModal;
    let formEditModal;
    let removeAssetsModal;
    let removeFindingsModal;
    let removeVulnerabilitiesModal;
    let addAssetsModal;
    let addFindingsModal;
    let addVulnerabilitiesModal;
    let reload_edit_modal = $state(false);
    let tableElement = $state();
    let checkbox;
    let showSettings = $state(false);

    // NUCLEAR OPTION: Intercepts all close triggers natively
    const handleModalDismiss = (e, modalInstance) => {
        if (e.target.closest('[data-bs-dismiss="modal"]')) {
            e.preventDefault();
            if (modalInstance) modalInstance.hide();
        }
    };

    const clickOutside = (node, callback) => {
        const handleClick = (event) => {
            if (
                node &&
                !node.contains(event.target) &&
                !event.defaultPrevented
            ) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return {
            destroy() {
                document.removeEventListener("click", handleClick, true);
            },
        };
    };

    const parseRows = (pageContent) => {
        pageContent.forEach((row) => {
            if (row["name"] && typeof row["name"] === "string") {
                row["name"] = { label: row.name, id: row.id };
            }

            if (row["asset"] && !row["asset"].loader) {
                row["asset"] = {
                    asset:
                        typeof row.asset === "string"
                            ? JSON.parse(row.asset)
                            : row.asset,
                    loader: assets,
                };
            }

            if (row["finding"] && !row["finding"].loader) {
                let fnd =
                    typeof row.finding === "string"
                        ? JSON.parse(row.finding)
                        : row.finding;
                if (Array.isArray(fnd)) {
                    for (let f of fnd) {
                        f.name = f.vulnerability;
                    }
                }
                row["finding"] = {
                    finding: fnd,
                    loader: findings.list,
                };
            }

            if (row["vulnerability"] && !row["vulnerability"].loader) {
                row["vulnerability"] = {
                    vulnerability:
                        typeof row.vulnerability === "string"
                            ? JSON.parse(row.vulnerability)
                            : row.vulnerability,
                    loader: vulnerabilities,
                };
            }
        });
        deselectAll();
        return pageContent;
    };

    let ptInstructs = [
        { key: "select", title: "", filterable: false, sortable: false },
        {
            key: "name",
            title: $format("list.columns.name"),
            filterable: false,
            parseAs: "component",
            dataComponent: AnchorRow,
        },
        {
            key: "asset",
            title: $format("list.columns.assets"),
            filterable: false,
            parseAs: "component",
            dataComponent: DropdownRow,
        },
        {
            key: "finding",
            title: $format("list.columns.findings"),
            filterable: false,
            parseAs: "component",
            dataComponent: DropdownRow,
        },
        {
            key: "vulnerability",
            title: $format("list.columns.vulnerabilities"),
            filterable: false,
            parseAs: "component",
            dataComponent: DropdownRow,
        },
    ];

    let ptOptions = {
        uniquePrefix: "tagTable",
        rowsPerPageOptions: [10, 20, 50, 100],
        footerText: false,
        footerFilters: false,
        footerLoadingBar: false,
        segments: {
            topBar: ["search"],
            pTable: ["table"],
            bottomBar: ["dropdown", "stats", "pagination"],
        },
        translations: powerTableService.getTableTranslations(),
        isDataRemote: false,
        userFunctions: {
            customParse: parseRows,
        },
    };

    const handleAdd = async (event, is_new = false) => {
        if (formAddModal) formAddModal.hide();
        if (formEditModal) formEditModal.hide();
        if (removeAssetsModal) removeAssetsModal.hide();
        if (removeFindingsModal) removeFindingsModal.hide();
        if (removeVulnerabilitiesModal) removeVulnerabilitiesModal.hide();
        if (addAssetsModal) addAssetsModal.hide();
        if (addFindingsModal) addFindingsModal.hide();
        if (addVulnerabilitiesModal) addVulnerabilitiesModal.hide();

        selected_rows = powerTableService.deselectAll();
        powerTableService.toggleActionButtons(selected_rows);
        showSettings = false;

        if (!is_new) {
            getTagsAndAssociations();
        } else {
            updateTags([event.detail.savedTag]);
        }
    };

    const handleAddAssets = async () => {
        if (selected_rows.length < 1)
            return notificate("select_element", "modal");
        if (selected_rows.length > 1)
            return notificate("select_only_one", "modal");
        await tick();
        if (addAssetsModal) addAssetsModal.show();
        showSettings = false;
        selected_rows = powerTableService.deselectAll();
    };

    const handleRemoveAssets = async () => {
        if (selected_rows.length < 1)
            return notificate("select_element", "modal");
        if (selected_rows.length > 1)
            return notificate("select_only_one", "modal");
        await tick();
        if (removeAssetsModal) removeAssetsModal.show();
        showSettings = false;
    };

    const handleAddFindings = async () => {
        if (selected_rows.length < 1)
            return notificate("select_element", "modal");
        if (selected_rows.length > 1)
            return notificate("select_only_one", "modal");
        await tick();
        if (addFindingsModal) addFindingsModal.show();
        showSettings = false;
    };

    const handleRemoveFindings = async () => {
        if (selected_rows.length < 1)
            return notificate("select_element", "modal");
        if (selected_rows.length > 1)
            return notificate("select_only_one", "modal");
        await tick();
        if (removeFindingsModal) removeFindingsModal.show();
        showSettings = false;
    };

    const handleAddVulnerabilities = async () => {
        if (selected_rows.length < 1)
            return notificate("select_element", "modal");
        if (selected_rows.length > 1)
            return notificate("select_only_one", "modal");
        await tick();
        if (addVulnerabilitiesModal) addVulnerabilitiesModal.show();
        showSettings = false;
    };

    const handleRemoveVulnerabilities = async () => {
        if (selected_rows.length < 1)
            return notificate("select_element", "modal");
        if (selected_rows.length > 1)
            return notificate("select_only_one", "modal");
        await tick();
        if (removeVulnerabilitiesModal) removeVulnerabilitiesModal.show();
        showSettings = false;
    };

    let handleDelete = async () => {
        let result = await notificate("confirm_delete", "modal", {
            massive: true,
            findings_warning: false,
        });
        if (!result.isConfirmed) {
            return false;
        }
        let ids = [];
        for (let row of selected_rows) {
            ids.push(row.id);
        }
        selected_rows = powerTableService.deselectAll();
        powerTableService.toggleActionButtons(selected_rows);
        tagService
            .del(ids)
            .then((response) => {
                dispatch("del", { ids });
            })
            .catch((error) => {
                return error;
            });
    };

    const selectAll = async (e) => {
        let tData = tableElement.getData(false, ["pageData", "matchedData"]);
        let pageData = tData.pageData;
        if (!pageData || pageData.length === 0) return selected_rows;

        const selectedIds = new Set(selected_rows.map((r) => r.id));
        const allPageSelected = pageData.every((el) => selectedIds.has(el.id));

        let action = allPageSelected ? "deselect" : "select";

        if (action === "select") {
            let result;
            if (tData.matchedData.length > 10) {
                result = await notificate("select_all", "modal", {});

                if (!result.isConfirmed && result.dismiss !== "cancel") {
                    return selected_rows;
                }
            }

            let target_elements =
                result && result.isConfirmed ? tData.matchedData : pageData;
            const currentIds = new Set(selected_rows.map((x) => x.id));
            let toAdd = target_elements.filter((x) => !currentIds.has(x.id));

            selected_rows = [...selected_rows, ...toAdd];
        } else {
            selected_rows = [];
        }

        powerTableService.toggleActionButtons(selected_rows);

        const domRows = document.querySelectorAll(
            `div[data-prefix='tagTable'] table tbody tr`,
        );

        const selectedPtIds = new Set(
            selected_rows.map((r) => String(r.__PT_ID__)),
        );

        domRows.forEach((row) => {
            let rowId = row.getAttribute("data-id");
            if (selectedPtIds.has(rowId)) {
                row.classList.add("selected");
            } else {
                row.classList.remove("selected");
            }
        });

        return selected_rows;
    };

    const selectAllEventListener = () => {
        checkbox = document.querySelector(
            "th[data-key='select'][data-sortable='false']",
        );
        if (checkbox) {
            checkbox.addEventListener("click", selectAll);
        }
    };
    const selectRow = (event) => {
        if (assets.loading || findings.loading || vulnerabilities.loading)
            return;
        let current = event.detail.data;
        let idx = selected_rows.findIndex((r) => r.id == current.id);
        selected_rows = powerTableService.selectRows(
            selected_rows,
            current,
            idx,
            "tagTable",
        );
        powerTableService.toggleActionButtons(selected_rows);
        reload_edit_modal = !reload_edit_modal;
        return selected_rows;
    };

    const deselectAll = () => {
        selected_rows = powerTableService.deselectAll();
        powerTableService.toggleActionButtons(selected_rows);
        return selected_rows;
    };

    const refresh = async () => {
        await getTagsAndAssociations();
    };

    $effect(() => {
        data.sort((v1, v2) => {
            return v1.name.localeCompare(v2.name);
        });
    });

    onMount(async () => {
        const bs =
            typeof bootstrap !== "undefined" ? bootstrap : window.bootstrap;
        if (bs) {
            const addModalEl = document.getElementById("tag-add-modal");
            if (addModalEl) formAddModal = new bs.Modal(addModalEl);

            const editModalEl = document.getElementById("tag-edit-modal");
            if (editModalEl) formEditModal = new bs.Modal(editModalEl);

            const addAssetsEl = document.getElementById("add-assets-modal");
            if (addAssetsEl) addAssetsModal = new bs.Modal(addAssetsEl);

            const remAssetsEl = document.getElementById("remove-assets-modal");
            if (remAssetsEl) removeAssetsModal = new bs.Modal(remAssetsEl);

            const addFindingsEl = document.getElementById("add-findings-modal");
            if (addFindingsEl) addFindingsModal = new bs.Modal(addFindingsEl);

            const remFindingsEl = document.getElementById(
                "remove-findings-modal",
            );
            if (remFindingsEl)
                removeFindingsModal = new bs.Modal(remFindingsEl);

            const addVulsEl = document.getElementById(
                "add-vulnerabilities-modal",
            );
            if (addVulsEl) addVulnerabilitiesModal = new bs.Modal(addVulsEl);

            const remVulsEl = document.getElementById(
                "remove-vulnerabilities-modal",
            );
            if (remVulsEl) removeVulnerabilitiesModal = new bs.Modal(remVulsEl);
        }

        selectAllEventListener();
    });

    onDestroy(() => {
        if (checkbox) checkbox.removeEventListener("click", selectAll);
    });
</script>

<div>
    <div class="card">
        <div class="card-header">
            <div class="float-end">
                {#if user.data.role != "viewer"}
                    <button
                        class="btn btn-secondary table-button btn-add btn-xs t-add-tag-btn"
                        tabindex="0"
                        aria-controls="tagTable"
                        type="button"
                        title={$format("buttons.add")}
                        id="tagAddBtn"
                        onclick={() => formAddModal && formAddModal.show()}
                        ><i class="fa fa-plus"></i></button
                    >

                    <button
                        class="btn btn-secondary table-button btn-delete btn-disabled btn-xs t-delete-tag-btn"
                        tabindex="0"
                        aria-controls="tagTable"
                        type="button"
                        title={$format("buttons.delete")}
                        id="tagDeleteBtn"
                        onclick={handleDelete}
                        ><i class="fa fa-trash"></i></button
                    >

                    <button
                        class="btn btn-secondary table-button btn-settings btn-disabled btn-xs t-settings-tag-btn"
                        tabindex="0"
                        aria-controls="tagTable"
                        type="button"
                        id="tagSettingsBtn"
                        onclick={() => (showSettings = !showSettings)}
                        ><i class="fas fa-cog"></i></button
                    >

                    {#if showSettings}
                        <div
                            class="dropdown d-inline-block"
                            use:clickOutside={() => (showSettings = false)}
                            transition:fade|global={{ delay: 0, duration: 50 }}
                        >
                            <ul
                                class="dropdown-menu dropdown-menu-lg dropdown-menu-right show"
                                style="left: inherit; right: 0px; position: absolute; margin-top: 2px;"
                            >
                                <li>
                                    <button
                                        class="dropdown-item table-button btn-edit btn-xs t-edit-asset-tag-btn"
                                        type="button"
                                        title={$format(
                                            "page.tag.associate_assets",
                                        )}
                                        onclick={handleAddAssets}
                                        >{$format(
                                            "page.tag.associate_assets",
                                        )}</button
                                    >
                                </li>
                                <li>
                                    <button
                                        class="dropdown-item table-button btn-edit btn-xs t-edit-finding-tag-btn"
                                        type="button"
                                        title={$format(
                                            "page.tag.associate_findings",
                                        )}
                                        onclick={handleAddFindings}
                                        >{$format(
                                            "page.tag.associate_findings",
                                        )}</button
                                    >
                                </li>
                                <li>
                                    <button
                                        class="dropdown-item table-button btn-edit btn-xs t-edit-vulnerability-tag-btn"
                                        type="button"
                                        title={$format(
                                            "page.tag.associate_vuls",
                                        )}
                                        onclick={handleAddVulnerabilities}
                                        >{$format(
                                            "page.tag.associate_vuls",
                                        )}</button
                                    >
                                </li>
                                <li><div class="dropdown-divider"></div></li>
                                <li>
                                    <button
                                        class="dropdown-item table-button btn-edit btn-xs t-edit-tag-btn"
                                        type="button"
                                        title="{$format('remove')} {$format(
                                            'association',
                                        )}"
                                        onclick={handleRemoveAssets}
                                        >{$format("remove")}
                                        {$format("assets")}</button
                                    >
                                </li>
                                <li>
                                    <button
                                        class="dropdown-item table-button btn-edit btn-xs t-edit-tag-btn"
                                        type="button"
                                        title="{$format('remove')} {$format(
                                            'association',
                                        )}"
                                        onclick={handleRemoveFindings}
                                        >{$format("remove")}
                                        {$format("findings")}</button
                                    >
                                </li>
                                <li>
                                    <button
                                        class="dropdown-item table-button btn-edit btn-xs t-edit-tag-btn"
                                        type="button"
                                        title="{$format('remove')} {$format(
                                            'association',
                                        )}"
                                        onclick={handleRemoveVulnerabilities}
                                        >{$format("remove")}
                                        {$format("vulnerablities")}</button
                                    >
                                </li>
                            </ul>
                        </div>
                    {/if}
                {/if}
                <button
                    class="btn btn-secondary table-button btn-refresh btn-xs t-refresh-tag-btn"
                    tabindex="0"
                    aria-controls="tagTable"
                    type="button"
                    title={$format("buttons.refresh")}
                    id="tagRefreshBtn"
                    onclick={() => refresh()}
                >
                    <i
                        class="fa fa-sync-alt"
                        class:fa-spin={loading ||
                            assets.loading ||
                            findings.loading ||
                            findings.list.loading ||
                            vulnerabilities.loading}
                    ></i>
                </button>
            </div>
        </div>

        <div class="card-body" style="z-index: 1;">
            <div class="table-responsive">
                <PowerTable
                    ptData={data}
                    {ptInstructs}
                    {ptOptions}
                    on:rowClicked={(e) => selectRow(e)}
                    bind:this={tableElement}
                >
                    {#snippet noResults()}{$format(
                            "results_not_found",
                        )}{/snippet}
                </PowerTable>
            </div>
        </div>
    </div>
</div>

<!-- MODAL -->
<div
    class="modal fade"
    id="tag-add-modal"
    tabindex="-1"
    aria-hidden="true"
    onclickcapture={(e) => handleModalDismiss(e, formAddModal)}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                {#if !ShowMassiveAdditionForm}
                    <h4 class="modal-title">
                        {$format("add")}
                        {$format("tag")}
                    </h4>
                {:else}
                    <h4 class="modal-title">
                        {$format("add")}
                        {$format("tag")}s
                    </h4>
                    <i
                        class="ms-2 mt-2 fas fa-question-circle"
                        title="Para cargar IPs masivamente, colóquelas una debajo de la otra como en el ejemplo. Si utiliza descripción será asociada a todos los registros agregados. Se acepta un máximo de 100 registros cada vez."
                    ></i>
                {/if}
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                ></button>
            </div>
            <div class="modal-body">
                <Form
                    tag={null}
                    on:save={(e) => handleAdd(e, true)}
                    on:cancel={() => formAddModal && formAddModal.hide()}
                />
            </div>
        </div>
    </div>
</div>
<!-- END MODAL-->

<!-- MODAL -->
<div
    class="modal fade"
    id="tag-edit-modal"
    tabindex="-1"
    aria-hidden="true"
    onclickcapture={(e) => handleModalDismiss(e, formEditModal)}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                {#if !ShowMassiveAdditionForm}
                    <h4 class="modal-title">Editar Etiqueta</h4>
                {:else}
                    <h4 class="modal-title">Editar Etiquetas</h4>
                    <i class="ms-2 mt-2 fas fa-question-circle"></i>
                {/if}
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                ></button>
            </div>
            <div class="modal-body">
                {#if !ShowMassiveAdditionForm}
                    {#key reload_edit_modal}
                        {#if selected_rows[0]}
                            <Form
                                tag={selected_rows[0]}
                                on:save={handleAdd}
                                on:cancel={() =>
                                    formEditModal && formEditModal.hide()}
                            />
                        {/if}
                    {/key}
                {:else}
                    <MassiveAddForm
                        on:save={handleAdd}
                        on:cancel={() => formEditModal && formEditModal.hide()}
                    />
                {/if}
            </div>
        </div>
    </div>
</div>
<!-- END MODAL-->

<!-- REMOVE ASSETS MODAL -->
<div
    class="modal fade"
    id="remove-assets-modal"
    tabindex="-1"
    aria-hidden="true"
    onclickcapture={(e) => handleModalDismiss(e, removeAssetsModal)}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">{$format("buttons.delete")} Activos</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                ></button>
            </div>
            <div class="modal-body">
                {#key reload_edit_modal}
                    {#if selected_rows[0]}
                        <RemoveTagAssets
                            tag={selected_rows[0]}
                            on:save={handleAdd}
                            on:cancel={() =>
                                removeAssetsModal && removeAssetsModal.hide()}
                        />
                    {/if}
                {/key}
            </div>
        </div>
    </div>
</div>
<!-- END MODAL-->

<!-- ADD ASSETS MODAL -->
<div
    class="modal fade"
    id="add-assets-modal"
    tabindex="-1"
    aria-hidden="true"
    onclickcapture={(e) => handleModalDismiss(e, addAssetsModal)}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Asociar Activos</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                ></button>
            </div>
            <div class="modal-body">
                {#key reload_edit_modal}
                    <AddAssetsTag
                        tag={selected_rows[0]}
                        limits={assetsLimits.data}
                        on:save={handleAdd}
                        on:cancel={() =>
                            addAssetsModal && addAssetsModal.hide()}
                    />
                {/key}
            </div>
        </div>
    </div>
</div>
<!-- END MODAL-->

<!-- REMOVE Finding MODAL -->
<div
    class="modal fade"
    id="remove-findings-modal"
    tabindex="-1"
    aria-hidden="true"
    onclickcapture={(e) => handleModalDismiss(e, removeFindingsModal)}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {$format("buttons.delete")} Hallazgos
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                ></button>
            </div>
            <div class="modal-body">
                {#key reload_edit_modal}
                    {#if selected_rows[0]}
                        <RemoveTagFindings
                            tag={selected_rows[0]}
                            vulnerabilities={vulnerabilities.data}
                            assets={assets.data}
                            on:save={handleAdd}
                            on:cancel={() =>
                                removeFindingsModal &&
                                removeFindingsModal.hide()}
                        />
                    {/if}
                {/key}
            </div>
        </div>
    </div>
</div>
<!--END MODAL-->

<!-- ADD FINDING MODAL -->
<div
    class="modal fade"
    id="add-findings-modal"
    tabindex="-1"
    aria-hidden="true"
    onclickcapture={(e) => handleModalDismiss(e, addFindingsModal)}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Asociar Hallazgos</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                ></button>
            </div>
            <div class="modal-body">
                {#key reload_edit_modal}
                    {#if selected_rows[0]}
                        <AddFindingsTag
                            tag={selected_rows[0]}
                            assets={assets.data}
                            findings={findings.data}
                            vulnerabilities={vulnerabilities.data}
                            on:save={handleAdd}
                            on:cancel={() =>
                                addFindingsModal && addFindingsModal.hide()}
                        />
                    {/if}
                {/key}
            </div>
        </div>
    </div>
</div>
<!-- END MODAL-->

<!-- REMOVE VULNERABILITY MODAL -->
<div
    class="modal fade"
    id="remove-vulnerabilities-modal"
    tabindex="-1"
    aria-hidden="true"
    onclickcapture={(e) => handleModalDismiss(e, removeVulnerabilitiesModal)}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {$format("buttons.delete")} Vulnerabilidades
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                ></button>
            </div>
            <div class="modal-body">
                {#key reload_edit_modal}
                    {#if selected_rows[0]}
                        <RemoveTagVulnerabilities
                            tag={selected_rows[0]}
                            vulnerabilities={$state.snapshot(
                                vulnerabilities.data,
                            )}
                            on:save={handleAdd}
                            on:cancel={() =>
                                removeVulnerabilitiesModal &&
                                removeVulnerabilitiesModal.hide()}
                        />
                    {/if}
                {/key}
            </div>
        </div>
    </div>
</div>
<!-- END MODAL-->

<!-- ADD VULNERABILITY MODAL -->
<div
    class="modal fade"
    id="add-vulnerabilities-modal"
    tabindex="-1"
    aria-hidden="true"
    onclickcapture={(e) => handleModalDismiss(e, addVulnerabilitiesModal)}
>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Asociar Vulnerabilidades</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    data-bs-dismiss="modal"
                ></button>
            </div>
            <div class="modal-body">
                {#key reload_edit_modal}
                    {#if selected_rows[0]}
                        <AddVulnerabilitiesTag
                            tag={selected_rows[0]}
                            vulnerabilities={$state.snapshot(
                                vulnerabilities.data,
                            )}
                            on:save={handleAdd}
                            on:cancel={() =>
                                addVulnerabilitiesModal &&
                                addVulnerabilitiesModal.hide()}
                        />
                    {/if}
                {/key}
            </div>
        </div>
    </div>
</div>

<!-- END MODAL-->

<style>
    .rotating-image {
        width: 100px;
        height: auto;
        animation: spin 2s linear infinite;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    .overlay-wrapper div {
        display: none;
    }
    .overlay-wrapper div.overlay {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-top: 20px;
    }
</style>
